import type { WhatsAppButtonType } from "@dashboardApi/apis/whatsappMessageTemplates/types";

export const cacheKey = "/engagement/whatsapp/message_templates/:messaging_service_id" as const;
export const HEADER_FORMATS = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  DOCUMENT: "DOCUMENT",
  LOCATION: "LOCATION",
  NO_HEADER: undefined,
} as const;

export const BUTTON_TYPE_CATALOG = "CATALOG" as const;
export const BUTTON_TYPE_MPM = "MPM" as const;
export const BUTTON_TYPE_SPM = "SPM" as const;
export type CatalogButtonType = typeof BUTTON_TYPE_CATALOG | typeof BUTTON_TYPE_MPM | typeof BUTTON_TYPE_SPM;

export const PRODUCT_CATALOG_BUTTON_TYPES: WhatsAppButtonType[] = [
  BUTTON_TYPE_CATALOG,
  BUTTON_TYPE_MPM,
  BUTTON_TYPE_SPM,
];

export const BUTTON_TYPE_FLOW = "FLOW" as const;
